export const environment = {
  production: false,
  name: 'staging',
  apiUrl: 'https://api.dev-modeler.nicosworld.eu',
  timeCloseModal: 2000,
  take: 1,
};
